export const PLANS = {
  free: { name: "Free Plan", price: 0, booksPerMonth: 0 },
  fun: { name: "Fun Pack", price: 6.99, booksPerMonth: 1 },
  excitement: { name: "Excitement", price: 15.99, booksPerMonth: 3 },
  epic: { name: "Epic Pack", price: 21.99, booksPerMonth: 5 },
};

export const PLAN_LIMITS = Object.fromEntries(
  Object.entries(PLANS).map(([key, plan]) => [key, plan.booksPerMonth])
);
